/* eslint-disable i18next/no-literal-string */

import { capitalCase } from 'change-case-all';

import { tracker } from 'utils/analytics';
import { EnrollmentSteps } from '../constants';

export type AnalyticsActions = 'Clicked' | 'Failed' | 'Submitted' | 'Succeeded' | 'Viewed';
type AnalyticsSources = 'Modal' | 'Page';

export type TrackEnrollmentArgs = {
  step: EnrollmentSteps;
  action: AnalyticsActions;
  source?: AnalyticsSources;
};

export const trackDutchiePayEnrollment = ({ step, action, source }: TrackEnrollmentArgs): void => {
  const formattedStep = capitalCase(step);
  const formattedAction = capitalCase(action);

  tracker.dutchiePayEnrollmentStep({ step: formattedStep, action: formattedAction, source });
};

export const trackedMxEvents: string[] = [
  'connected',
  'createMemberError',
  'loaded',
  'memberConnected',
  'oauthError',
  'oauthRequested',
  'selectedInstitution',
];

export const trackMXEvents = (type: string, list: string[] = trackedMxEvents): void => {
  const mxEvent = type.replace(/mx\/connect\//, '');

  if (!list.includes(mxEvent)) {
    return;
  }

  const formattedEvent = capitalCase(mxEvent);
  tracker.dutchiePayConnectBankStep({ action: formattedEvent, source: `MX Widget IFrame` });
};
